import { z } from 'zod';

import {
  AI_TOOL_SELECT_USAGE_NOTE,
  createAiToolFieldMaskSchema,
} from '@erikdakoda/ai-tool/findManyAiToolInput';
import { textSearchBaseInputSchema } from '@erikdakoda/ai-tool/textSearchBaseInputSchema';
import {
  BOT_AI_TOOL_RELATION_FIELDS,
  BOT_AI_TOOL_SCALAR_FIELDS,
  BOT_AI_TOOL_SEARCH_SCALAR_FIELDS,
  PROMPT_AI_TOOL_RELATION_FIELDS,
  PROMPT_AI_TOOL_SCALAR_FIELDS,
  PROMPT_AI_TOOL_SEARCH_SCALAR_FIELDS,
} from '../shared/botAiToolQueryInput';

export { textSearchBaseInputSchema };
export type { TextSearchBaseInput } from '@erikdakoda/ai-tool/textSearchBaseInputSchema';

export const searchBotsInputSchema = textSearchBaseInputSchema.extend({
  select: createAiToolFieldMaskSchema(BOT_AI_TOOL_SEARCH_SCALAR_FIELDS),
});

export const searchPromptsInputSchema = textSearchBaseInputSchema.extend({
  select: createAiToolFieldMaskSchema(PROMPT_AI_TOOL_SEARCH_SCALAR_FIELDS),
});

export const readBotInputSchema = z.object({
  botId: z.string().describe('Bot id to load.'),
  select: createAiToolFieldMaskSchema(BOT_AI_TOOL_SCALAR_FIELDS, BOT_AI_TOOL_RELATION_FIELDS),
});

export const readPromptInputSchema = z.object({
  promptId: z.string(),
  select: createAiToolFieldMaskSchema(PROMPT_AI_TOOL_SCALAR_FIELDS, PROMPT_AI_TOOL_RELATION_FIELDS),
});

export { AI_TOOL_SELECT_USAGE_NOTE };

export type SearchBotsInput = z.infer<typeof searchBotsInputSchema>;
export type SearchPromptsInput = z.infer<typeof searchPromptsInputSchema>;
export type ReadBotInput = z.infer<typeof readBotInputSchema>;

export const createBotSelectSchema = createAiToolFieldMaskSchema(
  BOT_AI_TOOL_SCALAR_FIELDS,
  BOT_AI_TOOL_RELATION_FIELDS,
);

export const createPromptSelectSchema = createAiToolFieldMaskSchema(
  PROMPT_AI_TOOL_SCALAR_FIELDS,
  PROMPT_AI_TOOL_RELATION_FIELDS,
);
